import React from "react";
import classes from "./Footer.css";

function Footer(props) {
  return (
    <div className={classes.Footer}>
      <h2 className={classes.FooterMessage}>©2025 by Core Technology Corporation</h2>
    </div>
  );
}

export default Footer;
